import { isNil } from "lodash";
import { trackerApi } from "../../../core/api/TrackerApi";
import { DefaultAutocomplete, DefaultAutocompleteProps } from "../../../core/components/autocomplete/DefaultAutocomplete";
import { useQueryArray } from "../../../core/components/helpers/queryHelper";

export interface SubCategoryAutocompleteDto {
    id: number,
    name: string
}


const fetchSubCategories = async (categoryId?: number): Promise<Array<SubCategoryAutocompleteDto>> => {


    if (isNil(categoryId) || isNaN(categoryId))
        return [];

    const data = await trackerApi.callServiceGet('/oot/generator/subCategories/' + categoryId)
    return data
}

interface SubCategoryAutocompleteProps extends DefaultAutocompleteProps<SubCategoryAutocompleteDto> {
    selection: SubCategoryAutocompleteDto | null
    categoryId?: number
}

export const SubCategoryAutocomplete = (props: SubCategoryAutocompleteProps) => {


    const querySubCategoriesAutocomplete = useQueryArray<SubCategoryAutocompleteDto>(['/oot/generator/subCategories', props.categoryId], () => fetchSubCategories(props.categoryId), 'SubCategory Autocomplete');

    return (
        <DefaultAutocomplete<SubCategoryAutocompleteDto>
            {...props}
            onChange={props.onChange}
            query={querySubCategoriesAutocomplete}
            displayFieldName='name'
            label="OoT Sub Category / Tournament"
            selection={props.selection}
        />
    )
}